import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface compInitState {
  data: [];
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedRow:any;
}
const initialState: compInitState = {
  data: [],
  selectedRow:{},
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchAllCompInitSales = createAsyncThunk(
  "FetchAllCompInitSales",
  async (data:any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.GETALLCOMPINIT,data);
      return response;
    } catch (err: any) {
    //   if (err.response && err.response.data) {
        return rejectWithValue(err);
    //   }
    //   return rejectWithValue("error occurred");
    }
  }
);

const CompInitsSlice = createSlice({
  name: "CompInitData",
  initialState,
  reducers: {
    emptyCompInitData:(state) => {
        state.data = initialState.data;
        state.error = initialState.error;
        state.isLoading = initialState.isLoading;
        state.selectedRow = initialState.selectedRow;
        state.status = initialState.status;
        state.statusCode = initialState.statusCode;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchAllCompInitSales.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchAllCompInitSales.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.statusCode = action.payload.status;
        state.data = action.payload.data;
      })
      .addCase(FetchAllCompInitSales.rejected, (state,action:PayloadAction<any>) => {
        state.isLoading = false;
        state.statusCode = action.payload.status;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const { emptyCompInitData }=CompInitsSlice.actions
export default CompInitsSlice.reducer